package horcrux.frontend.common.views.collections.editcollectionmenu

import horcrux.common.api.dtos.CollectionPrivacyType
import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.HasViewName
import horcrux.frontend.common.analytics.ScreenViewEvent
import horcrux.frontend.common.views.collections.CollectionNavigatorMenuOption
import react.FC
import react.PropsWithChildren

external interface EditChatPageCollectionMenuProps : PropsWithChildren {
    var globalAppState: GlobalAppState
}

enum class ManageChatPageMenuOptions(override val viewName: String) : HasViewName {
    CHAT_PAGE_DETAILS("View Chat Page Details"),
    DELETE("Delete Chat Page");
}

val EditChatPageCollectionMenu = FC<EditChatPageCollectionMenuProps> { props ->
    val collectionNavigatorState = props.globalAppState.collectionNavigatorState
    val currentCollectionMetadataMaybeState =
        props.globalAppState.currentChatPageMetadataMaybeState.get()?.collectionMetadata

    EditCollectionMenu {
        this.globalAppState = props.globalAppState
        this.menuItemDataList = listOf(
            MenuItemData(
                ManageChatPageMenuOptions.CHAT_PAGE_DETAILS,
                currentCollectionMetadataMaybeState
            ) { closeMenu ->
                currentCollectionMetadataMaybeState?.let {
                    collectionNavigatorState.showChatPageDetailsDialogState.setTrue()
                    closeMenu()
                    props.globalAppState.analyticsClient.log(ScreenViewEvent.COLLECTION_DETAILS)
                }
            },
            MenuItemData(ManageChatPageMenuOptions.DELETE, currentCollectionMetadataMaybeState) { closeMenu ->
                currentCollectionMetadataMaybeState?.let {
                    collectionNavigatorState.showDeleteChatPageDialogState.setTrue()
                    closeMenu()
                    props.globalAppState.analyticsClient.log(ScreenViewEvent.DELETE_COLLECTION)
                }
            },
        )
    }
}
